import React from 'react';
import ReactDom from 'react-dom';
import Recruit from './_components/Recruit';

import '../common';

ReactDom.render(<Recruit cat={1} />, document.getElementById('table'));